export default {"src":"kbwebsite/assets/_next/static/media/registeredIcon.6c80ea8e.svg","height":6,"width":8};